// extracted by mini-css-extract-plugin
export default {"ArchiveIconStyle":"MediaGalleryListFilters_ArchiveIconStyle__TgrOI"};